import React, { type ReactNode } from "react";

export type AmountBreakdownRow = {
  key: string;
  label: ReactNode;
  amount: ReactNode;
  /** Feather icon name shown before the label, e.g. "percent". */
  icon?: string;
  amountClassName?: string;
};

type AmountBreakdownTableProps = {
  rows: AmountBreakdownRow[];
  className?: string;
};

/**
 * Label to the left, amount to the right (ClickUp 869fmxjbb). Shared by the
 * fee breakdown in the transaction list and the held funds per contract and
 * stage, so both parties read amounts in the same pattern.
 */
export function AmountBreakdownTable({ rows, className }: AmountBreakdownTableProps) {
  return (
    <table
      className={`table table-sm table-borderless mb-0 amount-breakdown-table${className ? ` ${className}` : ""}`}
    >
      <tbody>
        {rows.map((row) => (
          <tr key={row.key}>
            <td className="ps-0">
              {row.icon && (
                <i
                  className={`feather-${row.icon} me-2 text-muted amount-breakdown-icon`}
                  aria-hidden="true"
                />
              )}
              {row.label}
            </td>
            <td className={`text-end pe-0${row.amountClassName ? ` ${row.amountClassName}` : ""}`}>
              {row.amount}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
